<template>
  <div :class="$route.name">
    <div class="app-header">
      <app-f-header></app-f-header>
      <!-- <div class="app-header-left c-f-left">
          <app-title class="c-f-left" homeUrl="/" @goHome="onClickTitle"></app-title>
          <app-project class="c-f-right"></app-project>
      </div>
        <app-menu class=""></app-menu>
        <app-logout></app-logout> -->
    </div>
    <div class="app-main">
      <slot></slot>
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view />
        </keep-alive>
      </transition>
    </div>
    <!-- </el-container> -->
    <!-- <page-tips v-if="tipsAs"></page-tips> -->
    <page-questionnaire v-if="surveyUrl"></page-questionnaire>
    <page-contact></page-contact>
  </div>
</template>
<script>
import AppFHeader from '@/components/app-layout/header/index.vue'
// import appMenu from './app-menu'
// import appTitle from './app-title'
// import appLogout from './app-logout'
// import appProject from './app-project'
import pageQuestionnaire from './page-questionnaire'
import pageContact from '@/components/app-layout/page-contact'
export default {
  components: {
    AppFHeader,
    // appMenu,
    // appTitle,
    // appLogout,
    // appProject,
    pageQuestionnaire,
    pageContact
  },
  data () {
    return {
      isCollapse: false,
      projectDialogVal: false
    }
  },
  computed: {
    tipsAs () {
      return this.$store.getters['app/tipsAs']
    },
    surveyUrl () {
      return !!this.$store.getters['app/surveyUrl']
    },
    leftWidth () {
      return this.isCollapse ? '65px' : '200px'
    }
  },
  methods: {
    onCollapseBtnClick () {
      this.isCollapse = !this.isCollapse
    },
    onClickTitle () {}
  }
}
</script>
